import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ControlPoint } from '../../bo/controlPoint';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { HttpService } from '../../services/http.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { SismographControlPointModalComponent } from '../sismograph-control-point-modal/sismograph-control-point-modal.component';
import { Sismograph } from 'src/app/bo/sismograph';

@Component({
  selector: 'app-sismograph-control-point',
  templateUrl: './sismograph-control-point.component.html',
  styleUrls: ['./sismograph-control-point.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SismographControlPointComponent implements OnInit {

  currentSiteId: number = undefined;

  modale: BsModalRef;
  proprietesAfficheesSismograph: ProprieteAffichee[] = [];
  tabSismograph = signal<Sismograph[]>([]);
  tabControlPoints: ControlPoint[] = [];
  modif: boolean;


  constructor(
    private readonly modalService: BsModalService,
    private readonly http: HttpService,
    private readonly fonctionsService: FonctionsService,
    private readonly utilService: UtilisateurService
  ) { }


  ngOnInit(): void {
    this.currentSiteId = this.utilService.currentSite()?.siteId;
    this.proprietesAfficheesSismograph = new Sismograph().getProprietesAffichees();
    this.modalService.onHide.subscribe((val: any) => {
      this.refresh()
    });
    this.refresh();
  }


  ouvrirModale(sismograph: Sismograph) {
    this.modif = false;
    this.fonctionsService.loading_screen(true);
    this.http.get<ControlPoint[]>('Sites/' + this.currentSiteId + '/ControlPoints', { transformCoord: false }).subscribe(resultat => {
      this.tabControlPoints = resultat;

      if (sismograph !== undefined) this.modif = true;

      let initialState = {
        modif: this.modif,
        sismographSelected: (sismograph !== undefined) ? sismograph : new Sismograph(),
        controlPointSelected: (sismograph !== undefined) ? this.tabControlPoints.find(c => c.controlPointId == sismograph?.controlPointId) : new ControlPoint(),
        listPoints: this.tabControlPoints
      };

      this.fonctionsService.loading_screen(false);
      this.modale = this.modalService.show(SismographControlPointModalComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState });
    }, () => {
      this.fonctionsService.loading_screen(false);
    });
  }



  refresh() {
    this.fonctionsService.loading_screen(true);
    this.http.get<Sismograph[]>('Vibrations/' + this.currentSiteId + '/AllSismographBySiteId').subscribe(resultat => {
      this.tabSismograph.set(resultat);
      this.fonctionsService.loading_screen(false);
    }, () => {
      this.fonctionsService.loading_screen(false);
    });
  }



}
